import { render, staticRenderFns } from "./SvgProgramIntro.vue?vue&type=template&id=5cd1e640&scoped=true"
import script from "./SvgProgramIntro.vue?vue&type=script&lang=js"
export * from "./SvgProgramIntro.vue?vue&type=script&lang=js"
import style0 from "./SvgProgramIntro.vue?vue&type=style&index=0&id=5cd1e640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1e640",
  null
  
)

export default component.exports